/* eslint-disable @typescript-eslint/no-namespace */
import * as React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'state/reducer';

// If using TypeScript, add the following snippet to your file as well.
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'stripe-pricing-table': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
    }
  }
}

function PricingPage() {
  const user = useSelector((state: RootState) => state.user.user);
  return (
    <stripe-pricing-table
      style={{ flex: 1 }}
      pricing-table-id={process.env.REACT_APP_STRIPE_TABLE_ID}
      publishable-key={process.env.REACT_APP_STRIPE_PUPLISHER_KEY}
      customer-email={user?.email ? user.email : ''}
    ></stripe-pricing-table>
  );
}

export default PricingPage;
